import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：红人支付对象】
 * 生成日期：2025/11/24 19:38:23
 * 生成路径: src/api/artist_payment.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getArtistPaymentList(data) {
  return request.post('/artist_payment/list', data)
}
/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveArtistPayment(data) {
  return request.post('/artist_payment/store', data)
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getArtistPaymentInfo(id) {
  let data = { id: id }
  return request.post('/artist_payment/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryArtistPaymentInfo(where) {
  return request.post('/artist_payment/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteArtistPayment(id) {
  let data = { id: id }
  return request.post('/artist_payment/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importArtistPayments(data) {
  return request.post('/artist_payment/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportArtistPayments(data) {
  return request.postBlob('/artist_payment/export', data)
}